import * as React from 'react';
import injectSheet from 'react-jss';
import { Select, Button, Modal, Row, Col, Checkbox } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilter, applyFilter } from 'src/actions/inquiryFFActionBids';
import { globalShippingLines, globalAirlines } from 'src/selectors/importsFilter';
import { InquiryModes } from 'src/Library/Constants';
import { tokens } from 'src/design-system';

const Option = Select.Option;

const styles = theme => ({
  modal: {
    minWidth: '78%',
    '& .ant-modal-footer': {
      paddingTop:'0%',
      display: 'flex !important',
      marginLeft: '0.8% !important',
      border: 'none',
    },
    '& .ant-btn-primary': {
      backgroundColor: '#1875F0',
      border: '#1875F0',
    },
    '&. ant-modal-body': {
      paddingBottom: '10px',
    },
    position: 'absolute',
    marginLeft: '21%',
    marginTop: '1% !important',
  },
});
class FFBidsFilterModal extends React.PureComponent<any, any> {
  options = () => {
    const { globalCarrierLines } = this.props;
    const children: any = [];
    globalCarrierLines.map((carrierLine) => {
      children.push(<Option key={carrierLine.id}>{carrierLine.name}</Option>);
    });
    return children;
  }

  render() {
    const { visible, handleOk, handleCancel, classes, inquiryMode } = this.props;
    const defaultValue = this.props.filters.shippingLines;
    const dropdown = { maxWidth: '240px' };
    const options = [
      { label: 'Active', value: 'ACTIVE' },
      { label: 'Deleted', value: 'DELETED' },
    ];
    const selectLabel = (inquiryMode === 'AIRCARGO' ? 'Carriers' : 'Shipping Lines');
    return (
      <Modal
        className={classes.modal}
        width={'78%'}
        visible={visible}
        mask={false}
        onOk={() => {
          handleOk();
        }}
        onCancel={() => {
          handleCancel();
        }}
        okText="Apply"
        closable={false}
        footer={[
          <Button key="submit" style={{ marginLeft:'16%',
            background: tokens.colors.primary, border: tokens.colors.primary }}
          type="primary" onClick={() => handleOk()}>
            Apply
            </Button>,
          <Button key="back" onClick={() => handleCancel()}>
            Cancel
            </Button>,
        ]}
      >
        {![InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL].includes(inquiryMode) && <Row style={{ padding: '2px 0px' }}>
          <Col span={4}>
            <span style={{ padding: '0px 10px 0px', lineHeight: '2' }}>
              {selectLabel}</span>
          </Col>
          <Col span={20}>
            <Select
              showSearch
              mode="multiple"
              placeholder={`Search & Select ${selectLabel}`}
              defaultValue={defaultValue}
              onChange={shippingLines =>
                this.props.setFilter({ shippingLineList: shippingLines })}
              value={this.props.filters.shippingLineList}
              dropdownStyle={dropdown}
              style={{ minWidth: '33%' }}
            >
              {this.options()}
            </Select>
          </Col>
        </Row>}
        <div style={{ padding: '15px 0px 0px 10px' }}>
          <Checkbox.Group options={options}
          value={this.props.filters.bidStatusList}
          onChange={checkedValues =>
              this.props.setFilter({ bidStatusList: checkedValues })}
            />
        </div>
        <br />
      </Modal>
    );
  }
}

const mapStateToProps = ({ masterData, inquiryFFBidsReducer }, { inquiryMode }) => {
  return {
    inquiryMode,
    globalCarrierLines: inquiryMode === 'AIRCARGO'
      ? globalAirlines(masterData)
      : globalShippingLines(masterData),
    filters: inquiryFFBidsReducer.selectedFilters,
    appliedFilters: inquiryFFBidsReducer.appliedFilters,
  };
};

const mapDispatchToProps = dispatch => (bindActionCreators({
  setFilter,
  applyFilter,
}, dispatch));

export default injectSheet(styles)(connect(mapStateToProps, mapDispatchToProps)(FFBidsFilterModal));
